import React from 'react';
import { Section } from './ui/Section';
import { motion } from 'framer-motion';
export function Roadmap() {
  const stages = [{
    title: 'Marketing · Growth Acquisition',
    status: 'current',
    subtitle: 'Поточний етап програми',
    description: 'Формує керований потік можливостей для зростання',
    features: ['системне залучення клієнтів', 'управління попитом', 'прийняття маркетингових рішень власником']
  }, {
    title: 'Marketing · Growth Retention',
    status: 'next',
    subtitle: 'Наступний етап «Шляху лідера»',
    description: 'Зростання цінності та утримання клієнтів',
    features: ['повторні продажі', 'LTV і життєвий цикл клієнта', 'стабільність доходу без постійного Acquisition']
  }, {
    title: 'Фінанси',
    status: 'next',
    subtitle: '',
    description: 'Прогнозованість і контроль управлінських рішень',
    features: ['фінансова модель бізнесу', 'маржинальність і cash flow', 'рішення на основі цифр, а не інтуїції']
  }, {
    title: 'Менеджмент',
    status: 'next',
    subtitle: '',
    description: 'Система відповідальності та виконання',
    features: ['команда і ролі', 'процеси і KPI', 'власник виходить з операційки']
  }, {
    title: 'Продажі',
    status: 'next',
    subtitle: '',
    description: 'Системний, керований дохід',
    features: ['відділ продажів', 'воронки і конверсії', 'масштабування без ручного контролю']
  }];
  return <Section className="bg-transparent" data-id="element-394">
      <div className="text-center mb-16 max-w-4xl mx-auto" data-id="element-395">
        <h2 className="text-2xl md:text-4xl font-bold mb-4" data-id="element-396">
          Шлях лідера – це не курс. Це послідовність управлінських етапів.
        </h2>
        <p className="text-gray-400 text-lg" data-id="element-397">
          Кожен етап закриває конкретний рівень управління бізнесом
        </p>
      </div>

      {/* Timeline */}
      <div className="relative" data-id="element-398">
        {/* Timeline Line */}
        <div className="absolute top-8 left-0 w-full h-1 bg-gradient-to-r from-blue-500 via-blue-400/50 to-blue-400/30 hidden lg:block" data-id="element-399"></div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6 relative z-10" data-id="element-400">
          {stages.map((stage, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="relative" data-id="element-401">
              {/* Timeline Dot */}
              <div className="hidden lg:flex justify-center mb-4" data-id="element-402">
                <div className={`w-4 h-4 rounded-full ${stage.status === 'current' ? 'bg-blue-500 ring-4 ring-blue-500/30' : 'bg-blue-400/50'}`} data-id="element-403"></div>
              </div>

              <div className={`h-full rounded-2xl p-5 border transition-all ${stage.status === 'current' ? 'bg-blue-900/40 border-blue-500 shadow-lg shadow-blue-500/20' : 'bg-blue-900/20 border-blue-500/40'}`} data-id="element-404">
                {/* Title */}
                <h3 className={`font-bold text-sm mb-2 ${stage.status === 'current' ? 'text-white' : 'text-gray-300'}`} data-id="element-405">
                  {stage.title}
                </h3>

                {/* Status Badge */}
                {stage.status === 'current' && <div className="flex items-center gap-2 mb-3" data-id="element-406">
                    <span className="w-2 h-2 rounded-full bg-blue-400 animate-pulse" data-id="element-407"></span>
                    <span className="text-xs text-blue-400 font-bold uppercase tracking-wider" data-id="element-408">
                      Ви тут
                    </span>
                  </div>}

                {stage.subtitle && <p className="text-xs mb-2 text-blue-300" data-id="element-409">{stage.subtitle}</p>}

                {/* Description */}
                <p className="text-xs text-gray-400 mb-3 leading-relaxed" data-id="element-410">
                  {stage.description}
                </p>

                {/* Features */}
                <ul className="space-y-1.5" data-id="element-411">
                  {stage.features.map((feature, i) => <li key={i} className="flex items-start gap-2 text-xs text-gray-400" data-id="element-412">
                      <span className={`mt-1.5 w-1 h-1 rounded-full shrink-0 ${stage.status === 'current' ? 'bg-blue-400' : 'bg-blue-400/50'}`} data-id="element-413"></span>
                      {feature}
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>
      </div>
    </Section>;
}